import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface TipoFaltaOption {
  value: number;
  label: string;
}

export interface FaltaCreateDto {
  escalaEfetivoId: number;
  dataFaltaInicio: string;
  dataFaltaFim: string;
  justificada: boolean;
  tipoFaltaEnum: number;
  observacao: string;
}

interface TipoFaltaResponse {
  data?: Record<string, string>;
  retorno?: { codigo?: number; mensagem?: string };
}

@Injectable({ providedIn: 'root' })
export class FaltaService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiurl}/api`;

  getTipos(): Observable<TipoFaltaResponse> {
    return this.http.get<TipoFaltaResponse>(`${this.apiUrl}/Enum/TipoFalta`);
  }

  create(payload: FaltaCreateDto): Observable<string> {
    return this.http.post(`${this.apiUrl}/Falta`, payload, {
      responseType: 'text',
    });
  }

  getById(faltaId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/Falta/${faltaId}`);
  }

  remove(faltaId: number): Observable<string> {
    return this.http.delete(`${this.apiUrl}/Falta/${faltaId}`, {
      responseType: 'text',
    });
  }
}
